module.exports = __webpack_public_path__ + "static/img/5507_phase_function_Paper_PointsHejduk_Prediction.91db95b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5507_phase_function_Paper_PointsHejduk_Prediction.png
// module id = exEx
// module chunks = 0